// extracted by mini-css-extract-plugin
export default {"field":"EmployeeDetails-module__field--jRmpR"};